// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3fVhU","disabled":"FileBtn_disabled__3vam5","warn":"FileBtn_warn__2YCUU","fade":"FileBtn_fade__4m6yX"};